import { Route, Routes, useMatch } from 'react-router-dom';
import { Box } from '@medely/web-components';
import React from 'react';
import TopBarClean from './TopBarClean';
import TopBarDefault from './TopBarDefault';
import { useTheme } from '@medely/web-components/themes';

const useTopBarMode = (): 'default' | 'clean' | 'none' => {
  const isJobsScheduler = useMatch('/jobs/new');
  const isJobEdit = useMatch('/jobs/:id/edit');
  const isAssignmentJob = useMatch('/scheduler/assignments/jobs/new');
  const isAssignmentsScheduler = useMatch('/scheduler/assignments/new');
  const isTemplates = useMatch('/templates/manager');
  const isNewTemplate = useMatch('/templates/new');
  const isEditTemplate = useMatch('/templates/:id/edit');
  const isThankYou = useMatch('/thank-you');
  if (
    isJobsScheduler ||
    isJobEdit ||
    isAssignmentsScheduler ||
    isAssignmentJob ||
    isNewTemplate ||
    isEditTemplate
  ) {
    return 'clean';
  }
  if (isTemplates || isThankYou) {
    return 'none';
  }
  return 'default';
};

const TopBarContainer = (): React.ReactElement | null => {
  const mode = useTopBarMode();
  const theme = useTheme();
  if (mode === 'none') {
    return null;
  }
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: theme.palette.common.white,
        borderBottom: mode === 'default' ? `solid 1px ${theme.palette.grey[100]}` : undefined,
        boxShadow: mode === 'default' ? 'none' : '0 4px 4px 0 rgba(0, 0, 0, 0.15)',
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: 4,
        padding: '0 8px',
        position: 'sticky',
        top: 0,
        zIndex: 10,
        '& > *:not(:last-child)': {
          marginRight: '24px',
        },
      }}
    >
      <Routes>
        <Route
          path="/pro-pool/invite"
          element={<TopBarClean title="Workforce Invite" path="/" />}
        />
        <Route
          path="/pro-pool/invite-accepted"
          element={<TopBarClean title="Workforce Invite" path="/" />}
        />
        <Route path="*" element={<TopBarDefault />} />
      </Routes>
    </Box>
  );
};

export default TopBarContainer;
